import { withSvgIcon } from './withSvgIcon';

export const Sun = withSvgIcon(
  <>
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" />
    <path d="M12 5V2" stroke="currentColor" strokeWidth="2" />
    <path d="M12 22V19" stroke="currentColor" strokeWidth="2" />
    <path d="M5 12H2" stroke="currentColor" strokeWidth="2" />
    <path d="M22 12H19" stroke="currentColor" strokeWidth="2" />
    <path
      d="M7.12132 17.0193L5 19.1406"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M19.1421 4.99849L17.0208 7.11981"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M17.0193 17.0193L19.1406 19.1406"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M4.99849 4.99849L7.11981 7.11981"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
